import { Configuration } from "@azure/msal-browser";

// The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = {
    b2cScopes: ["https://b2ctestcasebuilder.onmicrosoft.com/testbuilder-api/testcasebuilder.read"],
    webApi: "https://b2ctestcasebuilder.azurewebsites.net/hello"
  };

//
// Enter here the user flows and custom policies for your B2C application
// To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
// To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
//
 export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_testcasebuilder_sisu"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://b2ctestcasebuilder.b2clogin.com/b2ctestcasebuilder.onmicrosoft.com/B2C_1_testcasebuilder_sisu",
        }
    },
    authorityDomain: "b2ctestcasebuilder.b2clogin.com"
};

// MSAL configuration
export const configuration: Configuration = {
    auth: {
      clientId: '39156cab-3f11-4f2e-b917-8101698a5aeb',
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      knownAuthorities: [b2cPolicies.authorityDomain] 
    }
  };

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["https://b2ctestcasebuilder.onmicrosoft.com/testbuilder-api/testcasebuilder.read"]
   };
/*

   // The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = {
  b2cScopes: ["https://anoojgrittest.onmicrosoft.com/testbuilder-api/testcasebuilder.read"],
  webApi: "https://anoojgrittest.azurewebsites.net/hello"
};

//
// Enter here the user flows and custom policies for your B2C application
// To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
// To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
//
export const b2cPolicies = {
  names: {
      signUpSignIn: "B2C_1_testcasebuilder_msal"
  },
  authorities: {
      signUpSignIn: {
          authority: "https://anoojgrittest.b2clogin.com/anoojgrittest.onmicrosoft.com/B2C_1_testcasebuilder_msal",
      }
  },
  authorityDomain: "anoojgrittest.b2clogin.com"
};

// MSAL configuration
export const configuration: Configuration = {
  auth: {
    clientId: '46395e89-90cd-421c-8bbb-0d2e1ed98de2',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain] 
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["https://anoojgrittest.onmicrosoft.com/testbuilder-api/testcasebuilder.read"]
 };
 */